import React from 'react';
import styled from 'styled-components';


/*

Props:


*/

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin-bottom: 30px;
  margin-right: 30px;
`;

const ModulesContainer = ({ styles, onClick, children }) => (
  <StyledDiv style = {styles}  onClick = {onClick}>
      { children }
  </StyledDiv>
)

export default ModulesContainer


// WEBPACK FOOTER //
// ./src/js/components/ModuleList/ModulesContainer.jsx